angular.module('nv.singleStudent').component('studentFullExamHistoryPanel', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-full-exam-history-panel.html'),
  bindings: {
    student: '=',
  },
  controller: 'StudentFullExamHistoryPanelCtrl',
});
